import React, { useState, useEffect, useMemo } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { confirmAlert } from "react-confirm-alert";
import { Flex, Button, Text } from "@mantine/core";
import { useAtom } from "jotai";

import createPaymentIntent from "utils/createPaymentIntent";
import { STRIPE_AC_ID, BOOKING_ID } from "constants";
import { step as eventStep } from "store/atoms";
import { ROUTE_NAMES } from "routes/names";

import EventInfoCard from "views/TicketBooking/EventInfoCard";
import EventBuyingSummary from "views/TicketBooking/EventBuyingSummary";
import { ErrorAlert, Loader, UserDetails } from "components";

import GoogleIcon from "assets/icon/Google.png";
import AppleIcon from "assets/icon/Apple.png";
import { ChevronsIconLeft } from "assets/icon";
import { createBookingBody } from "core/methods";
import { TwAppBar, TwButton, TwFooter } from "components/tailwind";
import TandCLink from "components/TandCLink";
import { updatestate } from "store/reducer";
import { BOOKINK_CART } from "constants";
import { BOOKINK_LINK } from "constants";
import cancelStripeIntent from "utils/cancelStripeIntent";
import logger from "utils/logger";

// Make sure to call loadStripe outside of a component’s render to avoid
// recreating the Stripe object on every render.
const stripePromise = loadStripe(
  process.env.REACT_APP_ENVIRONMENT === "PROD"
    ? process.env.REACT_APP_STRIPE_LIVE_KEY
    : process.env.REACT_APP_STRIPE_TEST_KEY
  // { stripeAccount: stripeAcId }
);
export default function SocialPayment() {

  const BOOKINKLINK = window.localStorage.getItem(BOOKINK_LINK);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { type } = location.state;
  const reduxstate = useSelector((state) => state.State);
  const stripeAcId = window.localStorage.getItem(STRIPE_AC_ID);
  const [, setEventStep] = useAtom(eventStep);

  const [stripe, setStripe] = useState(null);
  const [paymentRequest, setPaymentRequest] = useState(null);
  const [canMakePayment, setCanMakePayment] = useState({});
  const [processing, setProcessing] = useState(false);

  if (!BOOKINKLINK || BOOKINKLINK == null || BOOKINKLINK === "null") {
    navigate(`/`, { replace: true });
  } else if ((!stripeAcId || stripeAcId == null) && BOOKINKLINK && BOOKINKLINK !== "") {
    navigate(`${BOOKINKLINK}`, { replace: true });
  }

  useEffect(() => {
    let bookink_cart = window.localStorage.getItem(`${BOOKINK_CART}`);
    if (bookink_cart) {
      dispatch(updatestate({ ...Object.keys(bookink_cart).length > 0 ? JSON.parse(bookink_cart) : {} }));
    }
  }, []);

  async function getClientSecret() {
    const eventBookingPayload = createBookingBody({
      ...reduxstate.addParticipantData,
      paymentStatus: "Paid",
      // paymentMethod: "creditCard",
      paymentMethod: type === "google" ? "googlePay" : "applePay",
      paymentMode: "Online",
    });

    const body = {
      eventScheduleId: reduxstate.id,
      selectedEventPricing: reduxstate.selectedEventPricing
        .filter((item) => item.bookingQty && item.bookingQty > 0)
        .map(({ bookingQty, totalPrice, ticketType }) => ({
          bookingQty,
          totalPrice,
          ticketType,
        })),
      selectedAddonsPricing: eventBookingPayload.selectedAddonsPricing,
      eventBookingPayload,
    };

    const paymentMethod = type === "google" ? "googlePay" : "applePay";

    const res = await createPaymentIntent({
      amount: Number(reduxstate.totalPrice),
      body,
      paymentMethod,
    });
    return res;
  }

  async function cancelStripePaymentIntent({ stripePaymentIntent, accountId, reason }) {

    const body = {
      stripePaymentIntent: stripePaymentIntent,
      accountId: accountId,
      reason: reason,
    };
    setProcessing(true);
    const res = await cancelStripeIntent(body);
    setProcessing(false);
    return res;
  }

  let processingcheck = false
  useEffect(() => {
    // console.log("reduxstate.addParticipantData", reduxstate.addParticipantData);
    // console.log("processing == false && stripeAcId && reduxstate.addParticipantData", processing == false && stripeAcId && reduxstate.addParticipantData);
    // console.log("processing", processing);
    logger.log("processingcheck", processingcheck);

    if (processingcheck == false && stripeAcId && reduxstate.addParticipantData) {
      processingcheck = true
      setProcessing(true);
      loadStripe(
        process.env.REACT_APP_ENVIRONMENT === "PROD"
          ? process.env.REACT_APP_STRIPE_LIVE_KEY
          : process.env.REACT_APP_STRIPE_TEST_KEY,
        stripeAcId ? { stripeAccount: stripeAcId } : undefined
      ).then(async (stripeRes) => {
        // processingcheck = false
        setStripe(stripeRes);
        const getClientSecretResponse = await getClientSecret();
        const { client_secret, orderReferenceId, amountInCents, description, paymentIntent } = getClientSecretResponse;

        if (getClientSecretResponse.error == true) {
          confirmAlert({
            customUI: ({ onClose }) =>
              ErrorAlert({
                onClose: () => {
                  processingcheck = false
                  setProcessing(false);
                  onClose();
                  navigate(-1, { replace: true });
                },
                error: getClientSecretResponse.message,
                serverError: false,
              }),
            closeOnEscape: false,
            closeOnClickOutside: false,
          });
          return;
        }
        window.localStorage.setItem(BOOKING_ID, orderReferenceId);

        logger.log(amountInCents);
        const pr = stripeRes.paymentRequest({
          country: "NL",
          currency: "eur",
          total: {
            // label: description ? description : "Total",
            label: reduxstate?.eventData?.businessDetail?.myBusinessProfile?.businessName ||
              'tikitly',
            amount: amountInCents, // in cents
          },
          requestPayerName: true,
          requestPayerEmail: false,
        });
        pr.canMakePayment().then(async (result) => {
          logger.log(result);
          if (result) {
            setPaymentRequest(pr);
            setCanMakePayment(result);
          } else {
            const { } = await cancelStripePaymentIntent({
              stripePaymentIntent: paymentIntent.id,
              accountId: paymentIntent.stripeAccount,
              reason: "payment_canceled",
            });
            const typeCapitalized = type.charAt(0).toUpperCase() + type.slice(1);
            confirmAlert({
              customUI: ({ onClose }) =>
                ErrorAlert({
                  onClose: () => {
                    processingcheck = false
                    onClose();
                    navigate(-1, { replace: true });
                  },
                  error: `${typeCapitalized} Pay is not supported on this device. Please select another payment method.`,
                  serverError: false,
                }),
              closeOnEscape: false,
              closeOnClickOutside: false,
            });
          }
        });
        pr.on("paymentmethod", async (ev) => {

          const { error, paymentIntent } = await stripeRes.confirmCardPayment(
            client_secret,
            {
              payment_method: ev.paymentMethod.id,
              // ...(type === "google") ? {
              //   googlePay: {
              //     testEnv: process.env.REACT_APP_ENVIRONMENT !== "PROD",
              //     merchantName:
              //       reduxstate?.eventData?.businessDetail?.myBusinessProfile?.businessName ||
              //       'tikitly',
              //     countryCode: 'NL',
              //     currencyCode: 'EUR',
              //     billingAddressConfig: {
              //       format: 'FULL',
              //       isPhoneNumberRequired: true,
              //       isRequired: false,
              //     },
              //   },
              // } : {},
              // ...(type === "apple") ? {
              //   applePay: {
              //     cartItems: [
              //       {
              //         label: 'Processing Fee',
              //         amount: '0',
              //         paymentType: 'Immediate',
              //       },
              //       {
              //         label:
              //           reduxstate?.eventData?.businessDetail?.myBusinessProfile?.businessName ||
              //           'tikitly',
              //         amount: (amountInCents / 100).toString(),
              //         paymentType: 'Immediate',
              //       }
              //     ],
              //     merchantCountryCode: 'NL',
              //     currencyCode: 'EUR',
              //     requiredShippingAddressFields: [],
              //     requiredBillingContactFields: [],
              //   },
              // } : {}
            },
            { handleActions: false }
          );
          if (error) {
            ev.complete("fail");
            confirmAlert({
              customUI: ({ onClose }) =>
                ErrorAlert({
                  onClose: () => {
                    processingcheck = false
                    onClose();
                    navigate(-1, { replace: true });
                  },
                  error: error.message,
                  serverError: false,
                }),
              closeOnEscape: false,
              closeOnClickOutside: false,
            });
            return;
          }
          if (paymentIntent) {
            processingcheck = false
            ev.complete("success");
            if (paymentIntent.status === "requires_action") {
              await stripeRes.confirmCardPayment(client_secret);
            }
            if (paymentIntent.status === "succeeded") {
              const params = new URLSearchParams();
              params.append("payment_intent", paymentIntent.id);

              navigate(`${ROUTE_NAMES.PAYMENT_CHECK}?${params.toString()}`, {
                state: { paymentSuccess: true },
              });
            }
          }
        });
        pr.on("cancel", async () => {
          const { } = await cancelStripePaymentIntent({
            stripePaymentIntent: paymentIntent.id,
            accountId: paymentIntent.stripeAccount,
            reason: "payment_canceled",
          });
          confirmAlert({
            customUI: ({ onClose }) =>
              ErrorAlert({
                onClose: () => {
                  processingcheck = false
                  onClose();
                  navigate(-1, { replace: true });
                },
                error: "Payment cancelled.",
                serverError: false,
              }),
            closeOnEscape: false,
            closeOnClickOutside: false,
          });
          return;
        });
      });
      setProcessing(false);
    }
    // }, [stripeAcId, reduxstate.addParticipantData]);
  }, [stripeAcId]);

  const handleOpenSheet = () => {
    setProcessing(true);
    if (type === "google") {
      if (!canMakePayment.googlePay) {
        confirmAlert({
          customUI: ({ onClose }) =>
            ErrorAlert({
              onClose: () => {
                onClose();
                navigate(-1, { replace: true });
              },
              error:
                "Google Pay is not supported on this device. Please add a card to your Google Pay account and try again.",
              serverError: false,
            }),
          closeOnEscape: false,
          closeOnClickOutside: false,
        });
        setProcessing(false);
        return;
      }
      paymentRequest.show();
    } else if (type === "apple") {
      if (!canMakePayment.applePay) {
        confirmAlert({
          customUI: ({ onClose }) =>
            ErrorAlert({
              onClose: () => {
                onClose();
                navigate(-1, { replace: true });
              },
              error:
                "Apple Pay is not supported on this device. Please add a card to your Apple Pay account and try again.",
              serverError: false,
            }),
          closeOnEscape: false,
          closeOnClickOutside: false,
        });
        setProcessing(false);
        return;
      }
      setProcessing(false);
      paymentRequest.show();
    }
  };

  const handleChangePaymentMethod = () => {
    // setEventStep(3);
    setEventStep(2);
    navigate(-1, { replace: true });
  };

  const PayIcon = useMemo(() => {
    if (type === "google") {
      return () => (
        <img
          src={GoogleIcon}
          alt="Google Pay icon"
          style={{ width: 36, height: 36 }}
        />
      );
    }

    return () => (
      <img
        src={AppleIcon}
        alt="Apple Pay icon"
        style={{ width: 36, height: 36 }}
      />
    );
  }, [type]);

  if (!stripe || !paymentRequest || !Object.keys(canMakePayment).length) {
    return (
      <div className="ticket-view-loading">
        <Loader />
      </div>
    );
  }

  return (
    <div className="[wrapper] max-w-md w-full">
      <TwAppBar
        isBackBtnShow={true}
        onBackClick={() => { navigate(-1) }}
        title="Review & Pay"
      />
      <div className="[content] flex flex-col gap-6 bg-white">
        <EventInfoCard
          reduxstate={reduxstate}
          selectedStep={5}
          isReadMore={false}
          isReview={true}
          toggleReadMore={() => { }}
        />
        <UserDetails />
        <EventBuyingSummary reduxstate={reduxstate} />

        <div className=" pb-4 flex flex-col gap-4">
          <div className="px-4 bg-white">
            <div className="flex justify-between items-center gap-4 border-2 border-gray-300 rounded-xl p-4">
              <div className="flex gap-2 items-center">
                <PayIcon w={"32"} h={"32"} />
                <div className="flex flex-col">
                  <div className="text-lg font-bold">
                    {type.charAt(0).toUpperCase() + type.slice(1)} Pay
                  </div>
                  <div className="text-sm text-gray-500">
                  </div>
                </div>
              </div>
              <TwButton
                variant={"secondary-link"}
                className="!text-lg"
                onClick={handleChangePaymentMethod}
              >
                Change
              </TwButton>
            </div>
          </div>
        </div>
      </div>
      <TwFooter isShowReservation={true}>
        <div className="p-4 bg-white flex flex-col gap-2">
          <TwButton
            className="w-[96%]"
            onClick={handleOpenSheet}
            loading={processing}
            disabled={processing}
            actionLoading={processing}
          >
            Pay & Confirm booking
          </TwButton>
          <TandCLink />
        </div>
      </TwFooter>

    </div>
  );
}
